import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const reconExplorerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_BR_OUTPUT_RECORDS_SUCCESS: {
            const { columns, records, contextMenuItems, explorerViews = [] } = action.payload;
            let newcol = columns.filter(a => !a.field.includes('_supp_last_modified_date'));
            return {
                ...state,
                rowData: records,
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: newcol,
                },
                contextMenuItems,
                reconExplorerViews: explorerViews,
            };
        }
        case actionTypes.GET_RECON_MATCHED_DATA: {
            const { rule_name, ref_id, created_date } = action.payload.records[0];
            return {
                ...state,
                matchRuleName: rule_name,
                matchRefId: ref_id,
                matchDate: created_date,
            };
        }
        case actionTypes.GET_BR_TOTALCOUNT_SUCCESS: {
            const todayData = action.payload[0].records;
            const { records } = action.payload[1];
            const labelData = action.payload[2].records;
            const ageData = action.payload[3];
            const daysData = action.payload[4];
            return {
                ...state,
                totalCountData: records,
                todayCountData: todayData,
                labelData: labelData,
                ageData: ageData,
                daysData: daysData,
            };
        }
        case actionTypes.GET_ALLRECON_TOTALCOUNT_SUCCESS: {
            // const todayData = action.payload[0].records;
            const records = action.payload;
            // const labelData = action.payload[2].records;
            // const ageData = action.payload[3];
            // const daysData = action.payload[4];
            return {
                ...state,
                totalCountData: records,
                // todayCountData: todayData,
                // labelData: labelData,
                // ageData: ageData,
                // daysData: daysData
            };
        }
        case actionTypes.SET_RECON_EXPLORER_VIEWS: {
            return { ...state, reconExplorerViews: action.payload };
        }
        case actionTypes.GET_RECON_MATCHED_GROUP: {
            const { records, columns } = action.payload;
            return {
                ...state,
                rowData: records,
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: columns,
                },
            };
        }
        case actionTypes.GET_RECON_SUMMARY_DATA: {
            return {
                ...state,
                reconSummaryData: action.payload
            };
        }
        case actionTypes.GET_SOURCE_SUMMARY_DATA: {
            return {
                ...state,
                sourceSummaryData: action.payload
            };
        }
        case actionTypes.GET_EVENT_MONITORING_DATA: {
            return {
                ...state,
                rowData: action.payload.records,
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: action.payload.columns,
                },
            }
        }
        default:
            return state;
    }
};

export default reconExplorerReducer;
